import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { CheckProductExistFunctionParam, ProductsOptionsProps } from "./types"
import { ProductOption } from "./product-option"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { useRecoilValue } from "recoil"
const checkProductExist = ({
  variants,
  optionsSelected,
  optionIndex,
  optionValue,
  options
}: CheckProductExistFunctionParam) => {
  if (optionIndex === 0) return true
  if (optionIndex >= options.length) return false

  const anyVariant = variants.find(variant => {
    for (let i = 0; i < optionIndex; i++) {
      if (
        variant.option_values[i].value !== optionsSelected[options[i].id].value
      ) {
        return false
      }
    }
    return variant.option_values[optionIndex].value === optionValue
  })
  return !!anyVariant
}

const _ProductsOptions: React.FC<ProductsOptionsProps> = ({
  onChange,
  optionsSelected,
  handleUnselectProductOption,
  largeOptionsContainer
}): JSX.Element => {
  const { options, variants } = useRecoilValue(productOverlaySelector)
  return (
    <Flex
      flexDirection="column"
      ref={largeOptionsContainer}
      width="max-content"
      id="large-options-container"
    >
      {options.map((option, index) => (
        <ProductOption
          key={`ProductOptions-${option.id}`}
          handleUnselectProductOption={handleUnselectProductOption}
          selectedOption={optionsSelected[option.id]}
          option={option}
          isButtonGroup={true}
          isSmallMainScreen={/* isSmallMainScreen */ true}
          width={/* width */ 200}
          isMobile={/* isMobile */ true}
          onChange={onChange}
          isTransperent={/* isTransperent */ true}
          checkProductOptionExist={optionValue =>
            checkProductExist({
              variants,
              options,
              optionsSelected,
              optionIndex: index,
              optionValue
            })
          }
        />
      ))}
    </Flex>
  )
}

export const ProductsOptions = React.memo(_ProductsOptions)
